export default __webpack_public_path__ + "static/media/template11.4836adb5.svg";